import React, { useEffect, useRef } from 'react';

// Lightweight Matrix-style code rain on a canvas. Cyan/teal on transparent.
export default function MatrixRain({ className = '', opacity = 0.14 }) {
  const canvasRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let width, height, columns, drops, fontSize;
    const glyphs = '01</>{}[]=+-*/#$%&ABCDEF0123456789xADF3E7アカサタナハマヤラワ'.split('');

    const resize = () => {
      const parent = canvas.parentElement;
      width = canvas.width = parent.offsetWidth;
      height = canvas.height = parent.offsetHeight;
      fontSize = width < 640 ? 12 : 15;
      columns = Math.floor(width / fontSize);
      drops = Array.from({ length: columns }, () => Math.floor((Math.random() * height) / fontSize));
    };
    resize();
    window.addEventListener('resize', resize);

    const draw = () => {
      ctx.fillStyle = 'rgba(7, 10, 14, 0.10)';
      ctx.fillRect(0, 0, width, height);
      ctx.font = `${fontSize}px 'IBM Plex Mono', monospace`;
      for (let i = 0; i < columns; i++) {
        const text = glyphs[Math.floor(Math.random() * glyphs.length)];
        const x = i * fontSize;
        const y = drops[i] * fontSize;
        // leading char brighter
        ctx.fillStyle = Math.random() > 0.975 ? 'rgba(191, 251, 255, 0.9)' : 'rgba(0, 231, 255, 0.55)';
        ctx.fillText(text, x, y);
        if (y > height && Math.random() > 0.975) drops[i] = 0;
        drops[i]++;
      }
      rafRef.current = requestAnimationFrame(draw);
    };

    if (!reduced) {
      rafRef.current = requestAnimationFrame(draw);
    } else {
      // static faint frame
      ctx.font = `${fontSize}px 'IBM Plex Mono', monospace`;
      ctx.fillStyle = 'rgba(0, 231, 255, 0.25)';
      for (let i = 0; i < columns; i++) ctx.fillText(glyphs[i % glyphs.length], i * fontSize, (i % 20) * fontSize + 20);
    }

    return () => {
      window.removeEventListener('resize', resize);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return <canvas ref={canvasRef} className={className} style={{ opacity, position: 'absolute', inset: 0, width: '100%', height: '100%', pointerEvents: 'none' }} />;
}
